import { Suspense, lazy, useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import CurrentContext from "./utils/CurrentContext";
import { FileDownload } from "./utils/jsHelper.js";
import { ToastContainer } from "react-toastify";

const Home = lazy(() => import("./pages/homePage"));
const AmmoCan = lazy(() => import("./pages/smartObject_AmmoCan.js"));
const Fridge = lazy(() => import("./pages/smartObject_Fridge.js"));
const Fatboy = lazy(() => import("./pages/smartObject_Fatboy.js"));
const Centurion = lazy(() => import("./pages/smartObject_Centurion.js"));
const ClassicPlus = lazy(() => import("./pages/smartObject_ClassicPlus.js"));
const ClassicSelect = lazy(() =>
  import("./pages/smartObject_ClassicSelect.js")
);
const Colonial = lazy(() => import("./pages/smartObject_Colonial.js"));
const Franklin = lazy(() => import("./pages/smartObject_Franklin.js"));
const Franklinn = lazy(() => import("./pages/smartObject_Franklinn.js"));
const Freedom = lazy(() => import("./pages/smartObject_Freedom.js"));
const HomeSafes = lazy(() => import("./pages/smartObject_HomeSafe.js"));
const HomeSafesSe = lazy(() => import("./pages/smartObject_HomeSafeSe.js"));
const Collector = lazy(() => import("./pages/smartObject_Collector.js"));
const Lincoln = lazy(() => import("./pages/smartObject_Lincoln"));
const NationalMagnum = lazy(() =>
  import("./pages/smartObject_NationalMagnum.js")
);
const PremiumHomeSafes = lazy(() =>
  import("./pages/smartObject_PremiumHomesafes.js")
);
const Presidential = lazy(() => import("./pages/smartObject_Presidential.js"));
const Tactical = lazy(() => import("./pages/smartObject_Tactical.js"));
const Usa = lazy(() => import("./pages/smartObject_USA.js"));
const VaultDoor = lazy(() => import("./pages/smartObject_Vaultdoor.js"));
const ArViewer = lazy(() => import("./components/ARViewer.js"));
const Loader = lazy(() => import("./components/Loader.js"));
const ARViewerWrapper = lazy(() => import("./components/ARViewerWrapper.js"));
const ModelInspector = lazy(() => import("./pages/modelInspector.js"));

// import { doorOpen } from "./utils/signals.js";

export default function App() {
  const [displayMeasureTool, setDisplayMeasureTool] = useState(false);
  const [autoRotate, setAutoRotate] = useState(false);
  const [fullScreen, setFullScreen] = useState(false);
  const [doorOpen, setDoorOpen] = useState(false);
  const [current, setCurrent] = useState("");
  const [loading, setLoading] = useState(false);
  const [isARReady, setIsARReady] = useState(false);
  const [ARModelSrc, setARModelSrc] = useState(null);
  const [ARUnicode, setARUnicode] = useState(null);
  const [isAR, setIsAR] = useState(false);
  const [hingeType, SetHingeType] = useState({ Swing: "out", Hinge: "left" });
  const [orbitCamera, setOrbitCamera] = useState(false);

  const [isEditEnabled, setIsEditEnabled] = useState(false);

  const [lockVariant, setLockVariant] = useState("mechanicallock");
  const [colorVariant, setColorVariant] = useState({
    hardware: "blackchromehardware",
    outer: "bronzetextured",
    interior: "camelfabric",
    woodshelf: "pindotvelour",
    Swing: "out",
    Hinge: "left",
  });
  const [iframeMessage, setIframeMessage] = useState("");

  useEffect(() => {
    // Handler function for the message event
    const handleMessage = (event) => {
      // console.log(event.data, "event");
      if (event.data !== iframeMessage) {
        setIframeMessage(event.data);
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, [iframeMessage]);

  function handleTakeScreenshot() {
    const canvas = document.querySelector("canvas");
    if (canvas) {
      const url = canvas.toDataURL("image/jpeg");
      // console.log(url);
      // FileDownload(url, `${current}.jpg`);
      window.parent.postMessage({ type: "screenshotCaptured", url: url }, "*");
    } else {
      console.error("Canvas element not found!");
    }
  } 

  const customFunction = (iframeMessage) => {
    if (
      ["model", "color", "lock", "additional", "camera", "screenshot"].includes(
        iframeMessage?.type
      )
    ) {
      setARModelSrc(null);
      setARUnicode(null);
    }
    
    if (iframeMessage.type === "model") {
      if (iframeMessage.value) {
        setCurrent(iframeMessage.value);
      }
    } else if (iframeMessage.type === "color") {
      if (iframeMessage.outer) {
        setColorVariant((prevState) => ({
          ...prevState,
          hardware: iframeMessage.hardware,
          outer: iframeMessage.outer,
          interior: iframeMessage.interior,
        }));
      }
    } else if (iframeMessage.type === "lock") {
      if (iframeMessage.value) {
        setLockVariant(iframeMessage.value);
      }
    } else if (iframeMessage.type === "additional") {
      if (iframeMessage.woodshelf !== undefined) {
        setColorVariant((prevState) => ({
          ...prevState,
          woodshelf: iframeMessage.woodshelf,
        }));
      }
      if (iframeMessage.swing !== undefined) {
        setColorVariant((prevState) => ({
          ...prevState,
          Swing: iframeMessage.swing,
        }));
      }
      if (iframeMessage.hinge !== undefined) {
        setColorVariant((prevState) => ({
          ...prevState,
          Hinge: iframeMessage.hinge,
        }));
      }
    }else if (iframeMessage.type === "camera") {
      if (iframeMessage.value === "2d") {
        setOrbitCamera(false);
      }
      else {
        setOrbitCamera(true);
      }
    } else if (iframeMessage.type === "screenShot") {
      if (iframeMessage.value) {
        handleTakeScreenshot()
      }
    }
  };

  useEffect(() => {
    customFunction(iframeMessage);
  }, [iframeMessage]);

  useEffect(() => {
    console.log(orbitCamera);
  }, [orbitCamera]);

  const propObject = {
    current: current,
    setCurrent,
    colorVariant,
    setColorVariant,
    lockVariant,
    setLockVariant,
    isEditEnabled,
    setIsEditEnabled,
    loading,
    setLoading,
    isARReady,
    setIsARReady,
    ARModelSrc,
    setARModelSrc,
    ARUnicode,
    setARUnicode,
    isAR,
    setIsAR,
    doorOpen,
    displayMeasureTool,
    setDisplayMeasureTool,
    autoRotate,
    setAutoRotate,
    fullScreen,
    setFullScreen,
    doorOpen,
    setDoorOpen,
    orbitCamera,
    setOrbitCamera,
  };

  const routesMap = {
    "/": Home,
    "/ammocan": AmmoCan,
    "/fridge": Fridge,
    "/freedom": Freedom,
    "/usa": Usa,
    "/colonial": Colonial,
    "/franklin": Franklin,
    "/franklinn": Franklinn,
    "/lincoln": Lincoln,
    "/presidential": Presidential,
    "/classicselect": ClassicSelect,
    "/classicplus": ClassicPlus,
    "/magnum": NationalMagnum,
    "/fatboy": Fatboy,
    "/tactical": Tactical,
    "/homesafes": HomeSafes,
    "/homesafese": HomeSafesSe,
    "/collector": Collector,
    "/premium-homesafes": PremiumHomeSafes,
    "/vaultdoor": VaultDoor,
    "/centurion": Centurion,
    "/ar/preview/:token": ArViewer,
    "/inspector": ModelInspector,
  };

  const routes = Object.entries(routesMap).map(([path, Component]) => (
    <Route key={path} path={path} element={<Component />} />
  ));

  return (
    <Suspense fallback={<Loader loading={true} transparentBg={true} />}>
      <CurrentContext.Provider value={propObject}>
        <BrowserRouter>
          <Routes>
            {routes}
            <Route path="*" element={<h2>Page not Exist</h2>} />
          </Routes>
        </BrowserRouter>
        <ToastContainer
          position="bottom-center"
          autoClose={5000}
          hideProgressBar
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss={false}
          draggable
          pauseOnHover
          limit={5}
        />
        <Loader loading={loading} transparentBg={true} />
        <ARViewerWrapper />
      </CurrentContext.Provider>
    </Suspense>
  );
}
